import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Input, Container } from "reactstrap";
import alert from "../../../components/shared/common/alert";
import closeIcon from "../../../assets/images/cross.png";
// import closeIcon from "../../../assets/images/cross.png";


function InvitesTeammatesModal({
  toggle_intive_modal,
  invite_modal,
  magic_link,
   currentUser,
}) {
  const copyText = () => {
    let copyToClip = magic_link;
    var textArea = document.createElement("textarea");
    document.body.append(textArea);
    document.body.lastElementChild.value = copyToClip;
    document.body.lastElementChild.select();
    document.execCommand("copy");
    textArea.remove();
    alert(200, "Link copied successfully");
  };
  const teamName = currentUser?.team?.description;
  return (
    <section className="manage-team">

<Container>
          <div className="invite-team">
            <h5 className="heading">Share this link to invite your team </h5>
            <p className="para">
              Teammates can use this link to sign up and join your team.
              (Expires in 72 hours):
            </p>
            <div className="invite-team__flex">
              <div className="input">
                <input
                  type="text"
                  name="link"
                  placeholder={magic_link}
                />
              </div>
              <button onClick={copyText} className="copy-link">Copy Link</button>
              <button onClick={() => {
                  window.location.href = `mailto:concierge@gameapart.com?subject= Your being invited to a heyLIME team! &body=You’ve been invited to a heyLIME team!%0DTeam: ${teamName}%0DClick on the link below to join your team (link expires in 72 hours):%0D${magic_link}`;
                }} className="share-link">Share Link</button>
            </div>
            <img src={closeIcon} onClick = {()=>{toggle_intive_modal()}} className="closeIcon" alt="icon" />
          </div>
        </Container> 
      
    </section>
    // <>    <Modal
    //   className="invites-teammates-modal"
    //   centered
    //   isOpen={invite_modal}
    //   toggle={toggle_intive_modal}
    // >
    //   <ModalHeader toggle={toggle_intive_modal}></ModalHeader>
    //   <ModalBody>
    //     <h3>Invite Teammates</h3>
    //     <p className="my-3">
    //       Share this link to invite your team (Expires in 72 hours).
    //     </p>
    //     <div className="mb-4">
    //       <Input type="text" name="copy_link" placeholder={magic_link} />
    //     </div>
    //     <div className="d-flex justify-content-between">
    //       <button className="copy-btn" onClick={copyText}>
    //         Copy Link
    //       </button>
    //       <button className="share-btn">Share Link</button>
    //     </div>
    //   </ModalBody>
    // </Modal>
 
        // </>

  );
}

export default InvitesTeammatesModal;
